<div class="lefttrack">
  <div class="btn_tabs" id="topleftbtntabs">
    <button class="active" (click)="this.openTabTracking('objects', 1)">{{ 'Objects'| translate }}</button>
    <button (click)="this.openTabTracking('geozones', 2)">{{ 'Geozones'| translate }}</button>
    <button (click)="this.openTabTracking('drivers', 3)">{{ 'Drivers'| translate }}</button>
  </div>
  <div class="lefttrack-block">
    <div class="topleft" id="topleft">
      <app-devices-list [trackingMode]="false"></app-devices-list>
      <app-geozones-list></app-geozones-list>
      <app-drivers-list></app-drivers-list>
    </div>
  </div>
</div>
